import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/modern-minimalism.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LoadingProvider } from './components/Global/LoadingContext';
import { BranchProvider } from './components/Global/BranchContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LoadingProvider>
    <BranchProvider>
    <App />
    </BranchProvider>
    </LoadingProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
